module.exports = __webpack_public_path__ + "static/WEDDING E&M-608-400ecb1c7562fbd759ff4e974a8fb662.jpg";